import { render, staticRenderFns } from "./TagRemovable.vue?vue&type=template&id=11f5aba5&"
import script from "./TagRemovable.vue?vue&type=script&lang=js&"
export * from "./TagRemovable.vue?vue&type=script&lang=js&"
import style0 from "./TagRemovable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports